import React, { useCallback, useState, useEffect, useContext } from 'react';
import _ from 'lodash';
import { WizardPage, pageTemplateProps, WizardPageTemplate } from 'gw-portals-wizard-react';
import { useAuthentication } from 'gw-digital-auth-react';
import { useValidation } from 'gw-portals-validation-react';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { LocalDateUtil } from 'gw-portals-util-js';
import { ViewModelForm, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import metadata from './PolicyDetailsPage.metadata.json5';
import {CanceledPolicyComponent, AccountContactSearchComponent} from 'gw-capability-gateway-react';
import {AdditionalInsuredInterestComponent} from 'gw-capability-policychange-ho-react';
import PortalUtil from '../../../../utils/PortalUtil';
import { UserService, OrganizationService } from 'gw-capability-gateway';

function PolicyDetailsPage(props) {
    const { wizardData: submissionVM, updateWizardData, isNewSubmission, additionalWizardData, updateAdditionalWizardData } = props;
    const { onValidate, isComponentValid, initialValidation } = useValidation('PolicyDetailsPage');
    const { authHeader } = useAuthentication();
    const viewModelService = useContext(ViewModelServiceContext);
    const {dateUtil} = PortalUtil;
    const [isPageInitialized, setPageInitialized] = useState(false);
    const [accountContacts, setAccountContacts] = useState([{}]);
    const [producerCodeOrgValue, updateProducerCodeValue] = useState([]);
    const [isProducerCodesforFlexFund, setProducerCodesforFlexFund] = useState(false);

    useEffect(() => {        
        setPageInitialized(true);     
        const _contacts = submissionVM.baseData.account.accountContacts.value.map((c) => {
            c['id'] = c.publicID;
            return c;
        });
        _contacts.push({ id: "placeholder", displayName: "Search Existing Contacts" });
        setAccountContacts(_contacts);
        const accProducerCodes = [] ;
        const producerCodesPromise = OrganizationService.getProducerCodeForOrganization(submissionVM.baseData.value.account.producerCodes[0].organizationDTO, authHeader);
        producerCodesPromise.then((producerCodesResponse) => {
            _.each(producerCodesResponse, (producerCodeValue) => {
                accProducerCodes.push({code : producerCodeValue.code,name :  producerCodeValue.displayValue});
            });
            updateProducerCodeValue(accProducerCodes);
        }, () => {
        });

        LoadSaveService.isProducerCodesforFlexFund(
            submissionVM.baseData.producerCode.value,
            authHeader
        ).then((response) => {
            if(response === true){
                setProducerCodesforFlexFund(true);
            }
        });
        if(submissionVM.baseData.periodStatus.value.code === 'Quoted') {
            updateAdditionalWizardData({isFarmLineQuoted: true})
        }
    }, []);

    const onNext = useCallback(async () => {
        _.unset(submissionVM.value, 'bindData');
        submissionVM.value = await LoadSaveService.updateDraftSubmission(
            submissionVM.value,
            authHeader
        );
        return submissionVM;
    }, [submissionVM, authHeader]);

    const handlePriorCancelHistoryChange = (value) => {
        _.set(submissionVM, 'baseData.hasAnyCancel', value);
        submissionVM.baseData.priorCancelledRecords.value = []
        updateWizardData(submissionVM);
    }

    const updatePackage = (value, index) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        updateWizardData(newSubmissionVM);
    }

    const updateAdditionalInsured = (value, index) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, `baseData.additionalNamedInsureds.children.${index}.value`, value);
        updateWizardData(newSubmissionVM);
    }

    const writeValue = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);
            if(path == 'baseData.termType' || path == 'baseData.periodStartDate'){
                const term = _.get(submissionVM, 'baseData.termType.value');
                const startDate = _.get(submissionVM, 'baseData.periodStartDate.value');
                let endDate = null
                if(term.code == "HalfYear"){
                    endDate = new Date(new Date(startDate.year, startDate.month, startDate.day).setMonth(new Date(startDate.year, startDate.month, startDate.day).getMonth() + 6))
                }
                else {
                    endDate = new Date(new Date(startDate.year, startDate.month, startDate.day).setMonth(new Date(startDate.year, startDate.month, startDate.day).getMonth() + 12))
                }
                endDate = {year: endDate.getFullYear(), month: endDate.getMonth(), day: endDate.getDate()}
                _.set(submissionVM, 'baseData.periodEndDate', endDate)

            }
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const writeAdditionalInsuredValue = useCallback(
        (value, path) => {
            _.set(submissionVM, `baseData.${path}`, value);
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const handleTermTypeChange = useCallback( async (value) => {
        _.set(submissionVM, 'baseData.termType', value);
        _.unset(submissionVM.value, 'bindData');
       const response = await LoadSaveService.updateDraftSubmission(
            submissionVM.value,
            authHeader
        );  
        const newSubmissionVM = viewModelService.clone(submissionVM);      
        _.set(newSubmissionVM, 'baseData.periodEndDate', response.baseData.periodEndDate);
        updateWizardData(newSubmissionVM);

    }, [submissionVM, updateWizardData])

    const overrideProps = {
        '@field': {
            showOptional: true,
            labelPosition: 'left'
        },
        coverageStartDate: {
            minDate: dateUtil.addDaysToLocalDate(LocalDateUtil.today(), -15),
            onValueChange: writeValue
        },
        cancelledByInsuranceCompany:{
            onValueChange: handlePriorCancelHistoryChange
        },
        canceledPolicycomponentID: {
            submissionVM : submissionVM,
            updateWizardData: updateWizardData,
            visible : submissionVM.baseData.hasAnyCancel.value == true
        },
        accountContactSearchId: {
            submissionVM: submissionVM,
            accountContacts: submissionVM.baseData.account.accountContacts,
            accountNumber: submissionVM.baseData.accountNumber,
            updatePackage: updatePackage,
            authHeader: authHeader,
            onValueChange: writeValue,
            updateWizardData:updateWizardData
        },
        additionalInsured: {
            coverableVM: submissionVM.baseData,
            accountContacts: accountContacts,
            accountNumber: submissionVM.baseData.accountNumber.value,
            type: 'additionalInsured',
            updatePackage: updateAdditionalInsured,
            authHeader: authHeader,
            onValueChange: writeAdditionalInsuredValue,
            isSubmission: true,
            jobID: submissionVM.quoteID.value,
            updateAccountContacts: setAccountContacts,
        },
        termType: {
            onValueChange : handleTermTypeChange
        },
        submissionProducerCode: {
            availableValues: producerCodeOrgValue
        },
        overrideAmount: {
            visible : isProducerCodesforFlexFund === true
        },
    };

    const resolvers = {
        resolveComponentMap: {
            canceledpolicycomponent: CanceledPolicyComponent,
            accountContactSearch: AccountContactSearchComponent,
            additionalInsuredInterestComponent: AdditionalInsuredInterestComponent            
        },
    };

    const skipIntialValidation = async () => {
        const isValid = await initialValidation();
        return isValid && !isNewSubmission;
    }

    if (!isPageInitialized) {
        return null;
    }

    return (
        <WizardPage
            onNext={onNext}
            showPrevious={false}
            skipWhen={skipIntialValidation}
            disableNext={!isComponentValid || !submissionVM.aspects.valid || !submissionVM.aspects.subtreeValid}
            template={WizardPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrideProps}
                model={submissionVM}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

PolicyDetailsPage.propTypes = pageTemplateProps;
export default PolicyDetailsPage;
